import {
  CreateUpsellNotificationMessageDocument,
  CreateUpsellNotificationMessageMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface CreateUpsellNotificationMessageHook {
  loading: boolean
  sendUpsellNotificationMessage(source: string): void
}

export const useCreateUpsellNotificationMessage = (): CreateUpsellNotificationMessageHook => {
  const [createUpsellNotificationMessage, { loading }] = useMutation(
    CreateUpsellNotificationMessageDocument,
    {
      extractorFn: (data: CreateUpsellNotificationMessageMutation) =>
        data.projectManagementMutations.createProjectmanagementUpsellNotificationMessage,
    }
  )
  return {
    loading,
    sendUpsellNotificationMessage(source: string) {
      return createUpsellNotificationMessage({
        variables: { source },
      })
    },
  }
}
